import { parseAiMessageBlocks, splitInlineFormatting } from '../../utils/formatAiMessage';

function FormattedInline({ text }) {
  const parts = splitInlineFormatting(text);

  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return (
        <strong key={index} className="font-semibold text-foreground">
          {part.slice(2, -2)}
        </strong>
      );
    }
    return part;
  });
}

/**
 * Renderiza respostas do Evolution AI com parágrafos e listas legíveis.
 */
export function AiMessageContent({ content }) {
  const blocks = parseAiMessageBlocks(content);

  if (!blocks.length) {
    return null;
  }

  return (
    <div className="space-y-2.5">
      {blocks.map((block, index) => {
        if (block.type === 'ol') {
          return (
            <ol
              key={index}
              className="list-decimal space-y-1.5 pl-5 marker:font-medium marker:text-muted-foreground"
            >
              {block.items.map((item, itemIndex) => (
                <li key={itemIndex} className="pl-0.5">
                  <FormattedInline text={item} />
                </li>
              ))}
            </ol>
          );
        }

        if (block.type === 'ul') {
          return (
            <ul key={index} className="list-disc space-y-1.5 pl-5 marker:text-muted-foreground">
              {block.items.map((item, itemIndex) => (
                <li key={itemIndex} className="pl-0.5">
                  <FormattedInline text={item} />
                </li>
              ))}
            </ul>
          );
        }

        if (block.type === 'lines') {
          return (
            <div key={index} className="space-y-1.5">
              {block.lines.map((line, lineIndex) => (
                <p key={lineIndex}>
                  <FormattedInline text={line} />
                </p>
              ))}
            </div>
          );
        }

        return (
          <p key={index}>
            <FormattedInline text={block.text} />
          </p>
        );
      })}
    </div>
  );
}
